import { render, staticRenderFns } from "./EditNameAccountModal.vue?vue&type=template&id=54660c86&scoped=true"
import script from "./EditNameAccountModal.vue?vue&type=script&lang=js"
export * from "./EditNameAccountModal.vue?vue&type=script&lang=js"
import style0 from "./EditNameAccountModal.vue?vue&type=style&index=0&id=54660c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54660c86",
  null
  
)

export default component.exports